import du from './du' // 百度统计
import so from './360' // 360统计
import ga from './ga' // google统计

const isDev = process.env.NODE_ENV === 'development'

// 统计账号
const keys = {
  du: '92b404b362f5faaeeccf7e62f2836b56',
  so: '',
  ga: ''
}

export default {
  init() {
    if (isDev) return
    du.init(keys.du)
    so.init(so.du)
    ga.init(ga.du)
  },
  trackPageView(href) {
    if (isDev) return
    du.trackPageView(href)
    ga.trackPageView(href)
  },
  trackEvent(category, action, opt_label, opt_value) {
    if (isDev) return
    du.trackEvent(category, action, opt_label, opt_value)
    ga.trackEvent(category, action, opt_label, opt_value)
  }
}
